import { StyledAccountSettings } from './AccountSettings.style';
import UserDetails from './UserDetails';
import OrgsSelector from './OrgsSelector';
import Logout from './Logout/Logout';

const AccountSettings = ({
  username,
  email,
  imageUrl = null,
  orgs = [],
  provider,
  onOrgSelected,
  onLogoutClick,
}) => {
  const currentOrg = orgs.filter(org => org.isSelected)[0];

  return (
    <StyledAccountSettings>
      <UserDetails
        username={username}
        email={email}
        imageUrl={imageUrl}
        orgDetails={currentOrg}
        provider={provider}
      />
      {orgs.length > 1 && (
        <OrgsSelector orgs={orgs} onOrgSelected={onOrgSelected} />
      )}
      <Logout onLogoutClick={onLogoutClick} />
    </StyledAccountSettings>
  );
};

export default AccountSettings;
